import { localizeUrl, parseLocale } from '@tesla/parse-locale';
import cx from 'classnames';
import React from 'react';
import { Heading, Link } from '../index.js';
export const LocaleSelectorCountry = ({ alternates = {}, baseUrl = '', className, country, currentLocale = {
    countryCode: 'us',
    languageCode: 'en',
    localeCode: 'en-US',
}, currentUrlQuery, delimiter, localeOverrides = {}, onLocaleSelect, ...rest }) => {
    var _a, _b;
    const { countryCode, countryName, hiddenFromSelector, languages } = country;
    // if the Country has a language code set, we're gonna use it, otherwise we fall back to 'en'
    const countryNameLanguageCode = (_a = country === null || country === void 0 ? void 0 : country.countryNameLanguageCode) !== null && _a !== void 0 ? _a : 'en';
    if (hiddenFromSelector) {
        return null;
    }
    const selected = (currentLocale === null || currentLocale === void 0 ? void 0 : currentLocale.countryCode.toLocaleUpperCase()) === (countryCode === null || countryCode === void 0 ? void 0 : countryCode.toLocaleUpperCase());
    // Each language may contain a localized version of the country name.
    // Prefer that, then fall back to the default/international country name
    const localizedCountryName = ((_b = languages.find((lang) => {
        const langLocale = parseLocale(lang.localeCode).locale;
        const current = parseLocale(currentLocale === null || currentLocale === void 0 ? void 0 : currentLocale.localeCode).locale;
        return langLocale === current;
    })) === null || _b === void 0 ? void 0 : _b.countryNameLocalized) || countryName;
    return (React.createElement("div", { className: cx('tds-locale-selector-country', 'tds-card', 'tds-card--dense', {
            'tds-locale-selector-country--selected': selected,
            [`tds-country--${countryCode}`]: countryCode,
        }, className), ...rest },
        React.createElement(Heading, { is: "h3", looksLike: "h6", lang: countryNameLanguageCode }, localizedCountryName),
        languages.map((language) => {
            var _a, _b;
            const { languageCode, languageName, localeCode } = language;
            const normalizedLocaleCode = parseLocale(localeCode).locale;
            // Prefer explicitly defined alternate links, fall back to standard
            const href = ((_a = alternates[normalizedLocaleCode]) === null || _a === void 0 ? void 0 : _a.href) ||
                ((_b = alternates[normalizedLocaleCode.toLowerCase()]) === null || _b === void 0 ? void 0 : _b.href) ||
                localizeUrl(typeof window !== 'undefined' ? window.location.pathname || '' : '', {
                    baseUrl,
                    customLocaleMap: localeOverrides,
                    delimiter,
                    locale: normalizedLocaleCode,
                    query: currentUrlQuery,
                });
            return (React.createElement(Link, { className: cx('tds-locale-selector-language', {
                    'tds-locale-selector-language--selected': (currentLocale === null || currentLocale === void 0 ? void 0 : currentLocale.localeCode) === normalizedLocaleCode,
                    [`tds-lang--${languageCode}`]: languageCode,
                }), href: href, 
                // Hints at the language of the link to the browser
                // Actual SEO benefits expected from <link> tags in html/head
                hrefLang: languageCode, key: localeCode, lang: normalizedLocaleCode, onClick: (e) => {
                    if (onLocaleSelect) {
                        onLocaleSelect(e, normalizedLocaleCode);
                    }
                }, rel: "alternate", variant: "secondary" }, languageName));
        })));
};
